module.exports = __webpack_public_path__ + "static/media/edit.19a15ddd.svg";